import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./lang/setup";

Vue.use(VueI18n);

let locale;
switch ((navigator.language || 'en').toLowerCase()){ //определим язык по браузеру
  case 'ru':
  case 'ru_by':
  case 'ru_kg':
  case 'ru_kz':
  case 'ru_md':
  case 'ru_ru':
  case 'ru_ua':
  case 'be':
  case 'be_by':
  case 'uz':
  case 'uz_arab':
  case 'uz_arab_af':
  case 'uz_cyrl':
  case 'uz_cyrl_uz':
  case 'uz_latn':
  case 'uz_latn_uz':
  case 'ky':
  case 'ky_kg':
  case 'kk':
  case 'kk_kz':
  case 'ru-by':
  case 'ru-kg':
  case 'ru-kz':
  case 'ru-md':
  case 'ru-ru':
  case 'ru-ua':
  case 'be-by':
  case 'uz-arab':
  case 'uz-arab-af':
  case 'uz-cyrl':
  case 'uz-cyrl-uz':
  case 'uz-latn':
  case 'uz-latn-uz':
  case 'ky-kg':
  case 'kk-kz':
  case 'tg-tj':
  case 'uk-ua':
  case 'tg':
  case 'tg_tj':
  case 'uk':
  case 'uk_ua':
    locale = 'ru';
    break;
  default:
    locale = 'en';
    break;
}

const i18n = new VueI18n({
  locale: locale,
  messages,
});

export default i18n;
